// 版面切換：海報牆／清單。選擇寫進網址（lay）並記在瀏覽器。
import { t } from '../../i18n/zh-TW.ts';
import type { LayoutKey } from '../../storage/prefs.ts';
import { ICON, LayoutGrid, List, type LucideIcon } from '../../ui/icons/index.ts';

const OPTIONS: { key: LayoutKey; Icon: LucideIcon }[] = [
  { key: 'grid', Icon: LayoutGrid },
  { key: 'list', Icon: List },
];

export function LayoutToggle({ value, onChange }: { value: LayoutKey; onChange: (layout: LayoutKey) => void }) {
  return (
    <fieldset className="segmented segmented-icons layout-toggle">
      <legend className="sr-only">{t.layout.label}</legend>
      {OPTIONS.map(({ key, Icon }) => (
        <button
          key={key}
          type="button"
          className={value === key ? 'seg seg-on' : 'seg'}
          aria-pressed={value === key}
          aria-label={t.layout[key]}
          title={t.layout[key]}
          onClick={() => onChange(key)}
        >
          <Icon {...ICON} />
        </button>
      ))}
    </fieldset>
  );
}
